/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import actionTypes from "../actions";

let cartJson = window.localStorage.getItem("cart");
let cart = null;
if (cartJson === null) {
  cart = {
    sol: [],
    acc: [],
  };
} else {
  try {
    cart = JSON.parse(cartJson);
  } catch (e) {
    cart = {
      sol: [],
      acc: [],
    };
  }
}
let selectedPromoBan = window.localStorage.getItem("selectedPromoBan");
var shoppingCartJson = JSON.parse(window.localStorage.getItem("shoppingCart"));
const initialState = {
  componentList: [
    { name: "devices", lable: "Devices" },
    { name: "dataPlans", lable: "Data Plan" },
    { name: "smsPlans", lable: "Message Plan" },
    { name: "setup", lable: "Setup" },
    { name: "services", lable: "Services" },
    { name: "addons", lable: "Addons" },
  ],
  solutions: Array.isArray(cart.sol) ? cart.sol : [],
  accessories: Array.isArray(cart.acc) ? cart.acc : [],
  category: "",
  unApprovedArraySol: [],
  unApprovedArrayAcc: [],
  selectedPromoBan: selectedPromoBan ? selectedPromoBan : "",
  shoppingCart: Array.isArray(shoppingCartJson) ? shoppingCartJson : [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_TO_CART: {
      let solutions = [...state.solutions];
      let accessories = [...state.accessories];
      if (action.sol) {
        solutions.push({ ...action.sol });
      }
      let newAcc = [...action.acc];
      for (let i = 0; i < newAcc.length; i++) {
        if (newAcc[i].id) {
          let index = accessories.findIndex(
            (a) =>
              a.id === newAcc[i].id &&
              a.packageSolutionId === newAcc[i].packageSolutionId,
          );
          if (index > -1) {
            accessories[index].quantity += newAcc[i].quantity;
          } else {
            accessories.push({ ...newAcc[i] });
          }
        } else {
          accessories.push({ ...newAcc[i] });
        }
      }
      window.localStorage.setItem(
        "cart",
        JSON.stringify({ sol: solutions, acc: accessories }),
      );
      return {
        ...state,
        solutions,
        accessories,
      };
    }

    case actionTypes.SET_CART: {
      window.localStorage.setItem("shoppingCart", JSON.stringify(action.cart));
      return {
        ...state,
        shoppingCart: action.cart,
      };
    }

    case actionTypes.REMOVE_ITEM: {
      let solutions = [...state.solutions];
      let accessories = [...state.accessories];
      if (action.itemType === "SOL") {
        solutions.splice(action.index, 1);
      } else if (action.itemType === "ACC") {
        accessories.splice(action.index, 1);
      } else if (action.itemType === "COMP") {
        solutions[action.index][action.compType].splice(action.compIndex, 1);
      }
      window.localStorage.setItem(
        "cart",
        JSON.stringify({ sol: solutions, acc: accessories }),
      );
      if (solutions.length === 0) {
        window.localStorage.setItem("selectedPromoBan", "");
      }
      return {
        ...state,
        solutions,
        accessories,
      };
    }

    case actionTypes.CHANGE_QUANTITY: {
      let solutions = [...state.solutions];
      let accessories = [...state.accessories];
      if (action.itemType === "SOL") {
        solutions[action.index].quantity = Math.abs(
          Math.floor(+action.value ? +action.value : 1),
        );
      } else if (action.itemType === "ACC") {
        accessories[action.index].quantity = Math.abs(
          Math.floor(+action.value ? +action.value : 1),
        );
      } else if (action.itemType === "COMP") {
        solutions[action.index][action.compType][action.compIndex].quantity =
          Math.abs(Math.floor(+action.value ? +action.value : 1));
      }
      window.localStorage.setItem(
        "cart",
        JSON.stringify({ sol: solutions, acc: accessories }),
      );
      return {
        ...state,
        solutions,
        accessories,
      };
    }

    case actionTypes.CHANGE_DISCOUNT: {
      let solutions = [...state.solutions];
      let accessories = [...state.accessories];
      if (action.itemType === "SOL") {
        // solutions[action.index].discount = Math.abs(Math.floor(+action.value ? +action.value : 0))
        if (isNaN(action.value)) {
          solutions[action.index].discount = "";
        } else {
          if (+action.value > 0) {
            solutions[action.index].discount = +action.value
              ? +action.value
              : "";
          } else {
            solutions[action.index].discount = "";
          }
        }
      } else if (action.itemType === "ACC") {
        // accessories[action.index].discount = Math.abs(Math.floor(+action.value ? +action.value : 1))
        if (isNaN(action.value)) {
          accessories[action.index].discount = "";
        } else {
          if (+action.value > 0) {
            accessories[action.index].discount = +action.value
              ? +action.value
              : "";
          } else {
            accessories[action.index].discount = "";
          }
        }
      }
      window.localStorage.setItem(
        "cart",
        JSON.stringify({ sol: solutions, acc: accessories }),
      );
      return {
        ...state,
        solutions,
        accessories,
      };
    }

    case actionTypes.CLEAR_CART: {
      let solutions = [];
      let accessories = [];
      window.localStorage.setItem(
        "cart",
        JSON.stringify({ sol: solutions, acc: accessories }),
      );
      return {
        ...state,
        solutions,
        accessories,
      };
    }

    case actionTypes.CHANGE_CATEGORY: {
      return {
        ...state,
        category: action.category,
      };
    }

    case actionTypes.CHANGE_PARTNER: {
      return {
        ...state,
        partner: action.partner,
      };
    }

    case actionTypes.CHECK_UN_APPROVED_ITEMS: {
      let solutions = [...state.solutions];
      let accessories = [...state.accessories];
      var currentDate = new Date();
      let unApprovedArraySol = [];
      let unApprovedArrayAcc = [];
      //get all the solutions that are un approved
      if (solutions) {
        solutions.forEach(function (item) {
          let releaseDate = new Date(item.releaseDate);
          if (releaseDate != null && releaseDate > currentDate) {
            unApprovedArraySol.push({
              name: item.solution ? item.solution.name : item.name,
            });
          }
        });
      }
      //get all the accessories that are un approved
      if (accessories) {
        accessories.forEach(function (item) {
          let releaseDate = new Date(item.releaseDate);
          if (releaseDate != null && releaseDate > currentDate) {
            unApprovedArrayAcc.push({ name: item.name });
          }
        });
      }
      return {
        ...state,
        unApprovedArrayAcc: unApprovedArrayAcc,
        unApprovedArraySol: unApprovedArraySol,
      };
    }

    case actionTypes.CHECK_PROMO_BAN: {
      window.localStorage.setItem("selectedPromoBan", action.id);
      return {
        ...state,
        selectedPromoBan: action.id,
      };
    }

    default:
      return state;
  }
};

export default reducer;
